/**
 * Local image catalog.
 *
 * Images are downloaded from the reference site into `public/images/shp/`
 * by `scripts/fetch-site-images.ps1`. Re-run that script to refresh them.
 *
 * Only presentation layer — no business logic depends on this module.
 */

const DIR = '/images/shp';

/** Full-bleed banner backgrounds. */
export const BANNERS = {
  home: `${DIR}/images_galeri_40eefb5a-c298-4f3f-8a57-56096b8108a9_mobile.jpg`,
  wedding: `${DIR}/assets_images_dugun.jpg`,
  corporate: `${DIR}/assets_images_toplanti.jpg`,
  privateEvent: `${DIR}/assets_images_ozel-davetler.jpg`,
  venues: `${DIR}/assets_images_salonlar.jpg`,
  invitation: `${DIR}/assets_images_davet.jpg`,
} as const;

/** Editorial image + text rows on the landing page. */
export const EDITORIAL = [
  `${DIR}/assets_images_dugun1-2.jpg`,
  `${DIR}/assets_images_dugun2.jpg`,
  `${DIR}/assets_images_dugun3_v2.jpg`,
] as const;

/** Named venue/hall photographs. */
export const VENUES = [
  { name: 'Harem Bahçe', src: `${DIR}/assets_images_salonlar11.jpg` },
  { name: "Clement's Bahçe", src: `${DIR}/assets_images_salonlar12.jpg` },
  { name: 'Harem', src: `${DIR}/assets_images_salonlar1.jpg` },
  { name: 'Selamlık', src: `${DIR}/assets_images_salonlar2.jpg` },
  { name: 'Rıhtım', src: `${DIR}/assets_images_salonlar10.jpg` },
] as const;

/** Gallery strip. */
export const GALLERY = [
  `${DIR}/assets_images_galeri1.jpg`,
  `${DIR}/assets_images_galeri2.jpg`,
  `${DIR}/assets_images_galeri3.jpg`,
  `${DIR}/assets_images_galeri4.jpg`,
  `${DIR}/assets_images_galeri5.jpg`,
  `${DIR}/assets_images_galeri6.jpg`,
  `${DIR}/assets_images_galeri7.jpg`,
  `${DIR}/assets_images_galeri8.jpg`,
  `${DIR}/assets_images_galeri9.jpg`,
] as const;

/** Architecture / detail shots. */
export const ARCHITECTURE = [
  `${DIR}/assets_images_mimari1.jpg`,
  `${DIR}/assets_images_mimari2.jpg`,
  `${DIR}/assets_images_mimari3.jpg`,
  `${DIR}/assets_images_mimari4.jpg`,
] as const;

/**
 * Yalı photographs from the reference site's own gallery — exteriors, waterfront
 * facades, period interiors. These are the most "yalı-looking" assets we have,
 * so listing covers draw from this pool first.
 */
export const MANSION_SHOWCASE = [
  `${DIR}/images_galeri_0542c593-41c8-4c23-8354-30a574d8a032_mobile.jpg`,
  `${DIR}/images_galeri_1ce22e44-7b84-4a82-80b9-cdc833e18b9b_mobile.jpg`,
  `${DIR}/images_galeri_2afadc02-c6b3-486f-829f-9917d62d8e73_mobile.jpg`,
  `${DIR}/images_galeri_426240ce-b1c6-4ae5-be1e-4930fb3f062c_mobile.jpg`,
  `${DIR}/images_galeri_4a5cbc63-d904-443d-919f-074d8c25d45a_mobile.jpg`,
  `${DIR}/images_galeri_4add4d31-9aac-4527-bd3b-843fe2c1c215_mobile.jpg`,
  `${DIR}/images_galeri_4c3efcc3-d27a-4433-9d7a-a4007350ab67_mobile.jpg`,
  `${DIR}/images_galeri_4e07eff7-3cde-4c02-8152-420ffa4debad_mobile.jpg`,
  `${DIR}/images_galeri_5a350d82-0cfd-4e8f-a6b9-13c75a85eeae_mobile.jpg`,
  `${DIR}/images_galeri_67eee5ed-8c61-4e49-93bf-b801401546e2_mobile.jpg`,
  `${DIR}/images_galeri_69345dae-1711-4480-8209-718635cbba68_mobile.jpg`,
  `${DIR}/images_galeri_69b3a5c3-28e5-43bb-9133-81a20b093eb0_mobile.jpg`,
  `${DIR}/images_galeri_6df0cfde-e21c-4391-a7f0-a5ec102c91bc_mobile.jpg`,
  `${DIR}/images_galeri_6fe09ade-852b-4d67-b16a-0c709b13ec9c_mobile.jpg`,
  `${DIR}/images_galeri_779c4515-e0bd-42c3-a96a-7a419440e892_mobile.jpg`,
  `${DIR}/images_galeri_8159ae72-3132-41d4-b903-b632fb5b14c7_mobile.jpg`,
  `${DIR}/images_galeri_85b3f8c4-2b5b-4102-86c1-e74ddb6d42c4_mobile.jpg`,
  `${DIR}/images_galeri_92f43bcf-e609-4569-8a14-3b42477620f3_mobile.jpg`,
  `${DIR}/images_galeri_9b80c299-bd27-4a23-80b8-202a4fbdf7b8_mobile.jpg`,
  `${DIR}/images_galeri_a04c5740-184e-455b-9608-626d89f954ad_mobile.jpg`,
  `${DIR}/images_galeri_a38e9573-fbac-4191-a65b-e3f5b9b931ae_mobile.jpg`,
  `${DIR}/images_galeri_a3e1f429-7a4c-4328-8784-e472957f8e2f_mobile.jpg`,
  `${DIR}/images_galeri_b0b1fa52-860e-4556-97b0-f4695facd5b2_mobile.jpg`,
  `${DIR}/images_galeri_b0b4752b-d956-4743-bd68-41542a57bfc0_mobile.jpg`,
  `${DIR}/images_galeri_b6ec5ce4-be99-4d96-b039-ccbac8ca3fa2_mobile.jpg`,
  `${DIR}/images_galeri_c3c14de2-7e7e-411a-be53-11eadb68da6f_mobile.jpg`,
  `${DIR}/images_galeri_c3ee06a6-dbba-4965-8fd8-f375b8ff05e2_mobile.jpg`,
  `${DIR}/images_galeri_c44de954-80c0-4cc2-a0e6-d9884bd4fa00_mobile.jpg`,
  `${DIR}/images_galeri_d586fbea-0978-4387-9a35-22ca7db6ed9e_mobile.jpg`,
  `${DIR}/images_galeri_d9a7b292-1ca3-46ee-83db-07689c939aad_mobile.jpg`,
  `${DIR}/images_galeri_e0eef646-5212-489b-9cbf-6371118d118a_mobile.jpg`,
  `${DIR}/images_galeri_e35d4878-705b-441f-b09f-fece4747b651_mobile.jpg`,
  `${DIR}/images_galeri_e4c9d268-1d5b-4ffc-a502-bd2e724e5851_mobile.jpg`,
  `${DIR}/images_galeri_ea65dc5c-ee8d-465a-b595-ce915c720ecd_mobile.jpg`,
  `${DIR}/images_galeri_f678d5cc-94d6-4d09-bbf1-a85247f74634_mobile.jpg`,
] as const;

/**
 * Feature image for the editorial intro block.
 * Colour photograph of a prepared reception area — no period portraits.
 */
export const FEATURE_DAVET = `${DIR}/images_davet-alani_b0b89447-58b4-43bc-aafc-1c0701121435_mobile.png`;

/**
 * Every photo usable as a listing cover, in a stable order.
 * Showcase yalı shots come first so most listings get a genuine mansion photo.
 */
export const COVERS: readonly string[] = [
  ...MANSION_SHOWCASE,
  ...ARCHITECTURE,
  ...VENUES.map((v) => v.src),
];

/**
 * Deterministic cover for a listing that has no uploaded photo.
 * Same id always resolves to the same image.
 */
export function coverFor(id: string | number): string {
  const key = String(id);
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return COVERS[hash % COVERS.length];
}
